import React from "react";

function ImageWithTag() {
  return (
    <>
      <div className="relative">
        <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/11-696x464.jpg" />
        <div className="absolute bottom-0 left-0 bg-black text-white text-xs-s py-1 px-1.5">New Looks</div>
      </div>
    </>
  );
}

export default ImageWithTag;
